import React, { useEffect, useState } from 'react';
import './mycss.css'
import { Link } from 'react-router-dom';


const MYProducts = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState({
    B_NO: '',
    B_ID: '',
    B_OD: '',
    TCHK: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(12);
  const [currentSet, setCurrentSet] = useState(0);
  const pagesPerSet = 5;

  // Function to fetch categories from the API
  const fetchCategories = async () => {
    try {
      const response = await fetch('https://www.hum.ujn.mybluehostin.me/new_clinet/snkb_api/category.php');
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  // Function to fetch products by category IDs
  const fetchProductsByCategories = async (categoryIds) => {
    try {
      const response = await fetch(`https://www.hum.ujn.mybluehostin.me/new_clinet/snkb_api/fetch_pro.php?categories=${categoryIds.join(',')}`);
      const data = await response.json();
      setProducts(data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  // Function to get URL parameters
  const getUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      categories: params.get('category') ? params.get('category').split(',') : [],
      cname: params.get('cname'),
    };
  };

  // Effect to fetch categories and set selected categories from URL
  useEffect(() => {
    fetchCategories();
    const urlParams = getUrlParams();
    setSelectedCategories(urlParams.categories);
  }, []);

  // Effect to fetch products when selected categories change
  useEffect(() => {
    if (selectedCategories.length > 0) {
      fetchProductsByCategories(selectedCategories);
    }
  }, [selectedCategories]);

  // Handle category change
  const handleCategoryChange = (categoryId) => {
    const index = selectedCategories.indexOf(categoryId);
    if (index === -1) {
      setSelectedCategories([...selectedCategories, categoryId]);
    } else {
      setSelectedCategories(selectedCategories.filter((id) => id !== categoryId));
    }
  };

  // Handle search change for each field
  const handleSearchChange = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };

  // Filter products based on search criteria
  const filteredProducts = products.filter((product) => {
    return (
      product.B_NO.toLowerCase().includes(search.B_NO.toLowerCase()) &&
      product.B_ID.toLowerCase().includes(search.B_ID.toLowerCase()) &&
      product.B_OD.toLowerCase().includes(search.B_OD.toLowerCase()) &&
      product.TCHK.toLowerCase().includes(search.TCHK.toLowerCase())
    );
  });

  // Get current products based on pagination
  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Get total pages and sets
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  const totalSets = Math.ceil(totalPages / pagesPerSet);

  // Get current set of pages
  const getPageSet = () => {
    const start = currentSet * pagesPerSet;
    const end = start + pagesPerSet;
    return [...Array(totalPages).keys()].slice(start, end);
  };

  // Calculate the range of products currently displayed
  const startProduct = indexOfFirstProduct + 1;
  const endProduct = Math.min(indexOfLastProduct, filteredProducts.length);

  return (
    <>


<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: "url('/assets/img/bg-img.png')" }}></div>
      <div className="line-box">
        <div className="line-1"></div>
        <div className="line-2"></div>
      </div>
      <div className="auto-container">
        <div className="content-box">
          <h1>Products</h1>
          <ul className="bread-crumb clearfix">
            <li> <Link   to ="/">Home </Link> </li>
            <li>Our Products</li>
          </ul>
        </div>
      </div>
    </section>

      <section className="shop-page-section">
        <div className="auto-container">
          <div className="row clearfix">
            {/* Sidebar */}
            <div className="col-lg-4 col-md-12 col-sm-12 sidebar-side">
              <div className="default-sidebar shop-sidebar">
                {/* Search widget */}
                <div className="search-widget" style={{ paddingTop: 50 }}>
                  <div className="search-form">
                    <div className="form-group">
                      <input
                        type="search"
                        name="B_NO"
                        value={search.B_NO}
                        onChange={handleSearchChange}
                        placeholder="Search BEARING NO"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="search"
                        name="B_ID"
                        value={search.B_ID}
                        onChange={handleSearchChange}
                        placeholder="Search ID"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="search"
                        name="B_OD"
                        value={search.B_OD}
                        onChange={handleSearchChange}
                        placeholder="Search OD"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="search"
                        name="TCHK"
                        value={search.TCHK}
                        onChange={handleSearchChange}
                        placeholder="Search THICKNESS"
                      />
                    </div>
                  </div>
                </div>
                {/* Category widget */}
                <div className="sidebar-widget category-widget">
                  <div className="widget-title">
                    <h3>Categories</h3>
                  </div>
                  <div className="widget-content">
                    <ul className="category-list clearfix">
                      {categories.map((category) => (
                        <li key={category.id}>
                          <input
                            type="checkbox"
                            id={`category_${category.id}`}
                            name="categories[]"
                            value={category.id}
                            className="category-checkbox"
                            checked={selectedCategories.includes(category.id.toString())}
                            onChange={() => handleCategoryChange(category.id.toString())}
                          />
                          <label htmlFor={`category_${category.id}`} className="category-name">
                          &nbsp; {category.name}
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* Product listing */}
            <div className="col-lg-8 col-md-12 col-sm-12 content-side">
              <div className="our-shop">
                <div className="item-shorting clearfix">
                  Showing {startProduct} - {endProduct} of {filteredProducts.length} Products
                </div>
                <div className="row clearfix">
                <div id="show_pro">
  {currentProducts.length === 0 ? (
    <p>No products found</p>
  ) : (
    <div className="row">
      {currentProducts.map(product => (
        <div key={product.ID} className="col-xxl-3 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 shop-block">
           <Link   to ={`/Product_Details?proid=${product.ID}`}>
            <div className="shop-block-one">
              <div className="inner-box">
                <div className="new-boxx">
                  <div className="offer-box" />
                  <figure className="image">
                    <img src={`assets/img/${product.category_img}`} alt={product.B_NO} />
                  </figure>
                </div>
                <div className="lower-content">
                  <h5>Bearing No : {product.B_NO}</h5>
                  <p>{product.category_name}</p>
                </div>
              </div>
            </div>
           </Link> 
        </div>
      ))}
    </div>
  )}
</div>

                </div>
                <div className="pagination-wrapper centred">
                  <ul className="pagination clearfix">
                    {currentSet > 0 && (
                      <li>
                         <Link  onClick={() => {
                          setCurrentSet(currentSet - 1);
                          setCurrentPage((currentSet - 1) * pagesPerSet + 1);
                        }}  to ="#">
                          &laquo; 
                         </Link> 
                      </li>
                    )}
{getPageSet().map((number) => (
  <li key={number} className={number + 1 === currentPage ? 'current' : ''}>
     <Link  onClick={() => paginate(number + 1)}  to ="#">
      {number + 1}
     </Link> 
  </li>
))}

{currentSet < totalSets - 1 && (
  <li>
    <Link
      onClick={() => {
        setCurrentSet(currentSet + 1);
        setCurrentPage((currentSet + 1) * pagesPerSet + 1);
      }}
       to ="#"
    >
      &raquo;
     </Link> 
  </li>
)}

</ul>
</div>
</div>
</div>
</div>
</div>
</section>
{/* Shop page section end */}
</>
);
};

export default MYProducts;
